<!--@formatter:off-->
<i18n src="./locale.json"></i18n>
<!--@formatter:on-->

<template lang="pug">
  .hide-class
    div.c-auth-page__head
      h1 {{ $t('h1') }}
      h2 {{ $t('h2') }}
    form-enter-number
</template>

<script>
import formEnterNumber from '../form-enter-number/component';

export default {
  name: 'FirstPageLogin',
  components: {
    formEnterNumber,
  },
};
</script>
<style scoped>
.is-loading-animation {
  animation: is-loading 0.7s infinite;
}
.forgot-password {
  margin-top: 16px;
}

@keyframes is-loading {
  0% {
  }
  50% {
    transform: scale(1.2);
    opacity: 0.6;
  }
  100% {
  }
}
</style>
>
